export default __webpack_public_path__ + "static/media/grafema_ummi_13.832bd0ab.jpg";